import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { CalendarService } from 'src/app/Service/Calendar/Calendar.service';

@Component({
  selector: 'app-CalendarList',
  templateUrl: './CalendarList.component.html',
  styleUrls: ['./CalendarList.component.scss']
})
export class CalendarListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Calendar_Service:CalendarService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Calendar:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1124).subscribe(
      data=>{
        this.ReadData_Calendar()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Calendar(){
    this.Procssing=true
    this.Calendar_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Calendar=data
        this.Procssing=false
      },error=>{
        this.Procssing=false
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Calendar_Service.Delete(item.id).subscribe(
      data=>{

        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Calendar()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}

